import {get, post} from "@/utils/http"

export const _getPagesList = params => get("/kindergarten/selectPages", params);
export const _del = params => get("/kindergarten/delete", params);
export const _edit = params =>post(params.id ? "/kindergarten/update" : "/kindergarten/save", params);
export const _updateStatus = params => get("/kindergarten/updateStatus", params);
export const _getBaseData = params => get("/kindergarten/getBaseData", params);

export const _kindergartens=params=>get("/kindergarten/findByInstitutionId",params)

